// extracted by mini-css-extract-plugin
export default {"headerWithBackNavWrapper":"styles_headerWithBackNavWrapper__BhhYD","layout":"styles_layout__SR9Wo","fullView":"styles_fullView__HBJTw","shimmer":"styles_shimmer__s7IOb"};